import { Box, Button, Divider } from "@mui/material";
import { useEffect, useMemo } from "react";
import { License, PriceCheck } from "./declarations/license";
import { StripePayment } from "./StripePayment";
import { PayPalPayment } from "./PayPalPayment";

export interface PaymentFormProps {
  licenses: License[];
  priceCheck: PriceCheck;
  onPriceChange?: (orderValue: PriceCheck) => void;
  sx?: Record<string, object | string | number>;
  onClick: () => void;
  onApprove: (firstName: string, lastName: string, email: string) => void;
  onError: () => void;
  onCancel: () => void;
  showPayPal?: boolean;
  disableFreeMode?: boolean;
}

export function PaymentForm({
  licenses,
  priceCheck,
  sx,
  onPriceChange: handleParentPriceChange,
  onClick,
  onApprove,
  onError,
  onCancel,
  showPayPal = true,
  disableFreeMode = false,
}: PaymentFormProps) {

  useEffect(() => {
    handleParentPriceChange && handleParentPriceChange(priceCheck);
    console.log("PaymentForm handleParentPriceChange(): priceCheck.price = " + priceCheck.price);
  }, [priceCheck, handleParentPriceChange]);

  const innerBoxStyle = useMemo(() => {
    return {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    };
  }, []);

  const gridContainer = useMemo(() => {
    return {
      display: "grid",
      gridTemplateColumns: "repeat(1, 1fr)",
      gap: 2,
    };
  }, []);

  const isFree = priceCheck.price === 0;
  const paymentDisabled = !disableFreeMode && isFree;
  const buttonText = (!disableFreeMode && isFree) ? "Get Free License" : "Submit Payment";
  const shouldShowPayPal = !paymentDisabled && showPayPal;
  const shouldShowStripe = !paymentDisabled;
  const shouldShowDivider = shouldShowPayPal && shouldShowStripe;

  return (
    <Box sx={gridContainer}>
      {shouldShowPayPal &&
        <Box>
          <PayPalPayment
            licenses={licenses}
            priceCheck={priceCheck}
            onClick={onClick}
            onApprove={onApprove}
            onError={onError}
            onCancel={onCancel}
          />
        </Box>
      }
      {shouldShowDivider &&
        <div>
          <Divider textAlign="center">or</Divider>
        </div>
      }
      {shouldShowStripe &&
        <Box>
          <StripePayment
            licenses={licenses}
            priceCheck={priceCheck}
          />
        </Box>
      }

      <Box sx={innerBoxStyle}>
        <Button variant="contained" size="large" type="submit">
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
}
